import React, { useEffect, useRef, useState } from "react";
import "./designation-tabs.scss";
import { AttributeFilter, CollectionDesignation, CollectionFilter } from "../../../common/interfaces";
import { AvailabilityFilter } from "../../containers/AvailabilityFilterContainer/AvailabilityFilterContainer";
import { CataloguePaginationData } from "../CataloguePagination";
import { createURLHashFromFilters, createURLHashFromPaginationData } from "../../../common/filterQueryUtils";
import debounce from "lodash.debounce";

const collectionDesignationTabLabels = {
  [CollectionDesignation.All]: "All",
  [CollectionDesignation.AvailableToBuy]: "Available To Buy",
  [CollectionDesignation.OnDemand]: "One Time Rental",
  [CollectionDesignation.Subscription]: "Membership"
};

export interface DesignationTabsProps {
  tabs: CollectionDesignation[];
  value: CollectionDesignation;
  cataloguePathname: string;
  filters: {
    collectionFilter: CollectionFilter;
    appliedAttributeFilters: AttributeFilter[];
    availabilityFilter: AvailabilityFilter;
  };
  paginationData: CataloguePaginationData;
}

interface DesignationTabProps {
  designation: CollectionDesignation;
  active: boolean;
  href: string;
}

export const DesignationTab: React.FC<DesignationTabProps> = ({ designation, active, href }) => {
  return (
    <a
      className={`c-new-designation-tabs__tab ${active ? "c-new-designation-tabs__tab--active" : ""}`}
      data-testid={`${active ? "" : "in"}active-designation-tab`}
      href={href}
    >
      {collectionDesignationTabLabels[designation]}
    </a>
  );
};

export const DesignationTabs: React.FC<DesignationTabsProps> = (props: DesignationTabsProps) => {
  const [isSticky, setSticky] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const handleScroll = () => {
    if (ref.current) {
      const designationTabOffset = ref.current.getBoundingClientRect().top;
      setSticky(window.pageYOffset >= designationTabOffset);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", debounce(handleScroll, 50));

    return () => {
      window.removeEventListener("scroll", () => handleScroll);
    };
  }, []);

  const { collectionFilter, availabilityFilter, appliedAttributeFilters } = props.filters;
  const paginationHash = createURLHashFromPaginationData(props.paginationData);
  const designationTabsClassName = isSticky
    ? "c-new-designation-tabs c-new-designation-tabs__sticky"
    : "c-new-designation-tabs";

  return (
    <div className={designationTabsClassName} ref={ref}>
      {props.tabs.map(designation => {
        let href =
          props.cataloguePathname +
          "#" +
          createURLHashFromFilters(
            { ...collectionFilter, collectionDesignation: designation },
            availabilityFilter,
            appliedAttributeFilters
          );
        const active = designation === props.value;

        if (active) {
          href += `&${paginationHash}`;
        }

        return <DesignationTab key={designation} designation={designation} active={active} href={href} />;
      })}
    </div>
  );
};
